import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import HintBox from '#components/m/HintBox'

function TerminConflictHint({conflictExists}) {
  return (
    <>
      {conflictExists.ausbilderTerminConflict && !conflictExists.gruppenTerminConflict && (
        <HintBox modifier="warning" text={i18n.t('termin_conflictexists_hint_ausbilder')} />
      )}
      {conflictExists.azubiTerminConflict && (
        <HintBox modifier="warning" text={i18n.t('termin_notdeletable_hint_ausbilder')} />
      )}
      {conflictExists.gruppenTerminConflict && (
        <HintBox modifier="warning" text={i18n.t('gruppentermin_notdeletable_hint_ausbilder')} />
      )}
    </>
  )
}
TerminConflictHint.propTypes = {
  conflictExists: PropTypes.shape({
    ausbilderTerminConflict: PropTypes.bool,
    azubiTerminConflict: PropTypes.bool,
  }),
}

export default TerminConflictHint
